import { render } from "./ReferralModal.vue?vue&type=template&id=5ffa6101&scoped=true"
import script from "./ReferralModal.vue?vue&type=script&lang=js"
export * from "./ReferralModal.vue?vue&type=script&lang=js"

import "./ReferralModal.vue?vue&type=style&index=0&id=5ffa6101&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffa6101"]])

export default __exports__